import React from 'react'
import Link from 'next/link'
import styles from './DynamicHero.module.scss'
import { Button } from '@mui/material'
import { ArrowForward } from '@mui/icons-material'

const DynamicHero = ({
  tag,
  line1,
  highlight,
  line2,
  paragraphs = [],
  image,
  buttonText,
  buttonLink,
  buttonClick,
  isSingleLine = false, className
}) => {
  return (
    <section className={`${className === "supplier-hero" ? styles.supplierHero : styles.hero} rsl__Wrapper_invest`}>
      {tag && <div className={styles.tag}>{tag}</div>}

      {!isSingleLine && (
        <h1 className={styles.title}>
          {line1}
          <br /> <span className={styles.highlight}>{highlight}</span> {line2}
        </h1>
      )}

      {isSingleLine && (
        <h1 className={styles.title}>
          {line1} <span className={styles.highlight}>{highlight}</span> {line2}
        </h1>
      )}

      {paragraphs.map((text, index) => (
        <p key={index} className={styles.paragraph}>
          {text}
        </p>
      ))}
      {image && (
        <div className={styles.heroImageWrapper}>
          <img
            src={`${process.env.IMAGE_BASE_URL}${image}`}
            alt='Dynamic Visual'
            className={styles.heroImage}
          />
        </div>
      )}

      {buttonText && buttonLink && (
        // <Link href={buttonLink} passHref>
        // <Button onClick={buttonClick} variant="contained"
        //   size="large"
        //   endIcon={<ArrowForward />}
        //   className={styles.ctaBtn}>
        //   {buttonText}</Button>

        <Button
          variant='contained'
          size='large'
          endIcon={<ArrowForward />}
          sx={{
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: 600,
            borderRadius: '8.87px',
            background: 'linear-gradient(to right, #9CD0C9, #32788E)',
            color: '#fff',
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
              background: 'linear-gradient(to right, #7BB9B2, #245E6E)',
              boxShadow: 'none'
            }
          }}
          onClick={buttonClick}
        >
          {buttonText}
        </Button>

        // </Link>
      )}
    </section>
  )
}

export default DynamicHero
